<template>
  <div class="node" :class="CSSnames_()" ref="node">
    <div class="info" v-if="!root">
      <div class="icons">
        <template v-if="folderIs">
          <span class="opener" ref="opener">
            <svg version="1.1" viewBox="0 0 4.2323 4.2261" xmlns="http://www.w3.org/2000/svg" shape-rendering="crispEdges">
              <path v-if="openedIs" d="m0.4 0c-0.2219 0-0.40049 0.1786-0.40049 0.40049v3.4251c0 0.21774 0.17199 0.39345 0.38809 0.39998l3.5109-6e-3c0.18948-0.032 0.33332-0.19546 0.33332-0.3943v-3.4251c0-0.2219-0.1786-0.40049-0.4005-0.40049zm0.2036 0.59945h3.0241v3.0148h-3.0241zm0.60513 1.2082v0.60462h1.8138v-0.60462z" fill="#4D4D4D" />
              <path v-else d="m0.4 0c-0.2219 0-0.40049 0.17859-0.40049 0.40049v3.4251c0 0.2219 0.17859 0.4005 0.40049 0.4005h3.4313c0.21874 0 0.39499-0.1737 0.39998-0.39119l5.3e-4 -3.4344v-1e-3c-5.7e-4 -0.22141-0.17895-0.39946-0.40049-0.39946zm0.20412 0.60616h3.0231v3.0148h-3.0231zm1.2092 0.60307v0.60461h-0.6041v0.60461h0.6041v0.60462h0.60461v-0.60462h0.60462v-0.60461h-0.60462v-0.60461z" fill="#4D4D4D" />
            </svg>
            <svg version="1.1" class="folder" viewBox="0 0 5.4624 4.2333" xmlns="http://www.w3.org/2000/svg" _shape-rendering="crispEdges">
              <path d="m2.59 0.69h2.5264c0.20486 0 0.3414 0.20485 0.3414 0.4097v2.7995c0 0.20485-0.13654 0.3414-0.3414 0.3414h-4.7796c-0.20485 0-0.3414-0.13655-0.3414-0.3414v-3.7554c0-0.0683 0.0683-0.13655 0.20485-0.13655h1.7753c0.13654 0 0.13654 0.0683 0.20485 0.13655l0.4097 0.54625z" fill="#4D4D4D" />
            </svg>
          </span>
        </template>
        <template v-else>
          <svg class="folder" version="1.1" viewBox="0 0 5.4564 4.2298" xmlns="http://www.w3.org/2000/svg">
            <path d="m0.45349 0c-0.25169 0-0.45349 0.2018-0.45349 0.45349v3.3228c0 0.25169 0.2018 0.45349 0.45349 0.45349h4.5494c0.25169 0 0.45349-0.2018 0.45349-0.45349v-3.3228c0-0.25169-0.2018-0.45349-0.45349-0.45349h-4.5494m0 0.45349h4.5494v3.3228h-4.5494v-3.3228m0.45349 0.46911v0.45349h3.6424v-0.45349h-3.6424m0 0.95385v0.45349h3.6424v-0.45349h-3.6424m0 0.96947v0.45349h2.1419v-0.45349z" fill="#4D4D4D" />
          </svg>
<!--
          <svg version="1.1" class="item" viewBox="0 0 3.9231 4.2333" xmlns="http://www.w3.org/2000/svg" _shape-rendering="crispEdges">
            <path d="m2.97 0v0.69637c0 0.0804 0.0727 0.14561 0.16219 0.14561h0.78569v-0.1212c0-0.0501-0.0222-0.0982-0.062-0.13392l-0.58907-0.53087c-0.0397-0.0357-0.0933-0.0556-0.14993-0.0556zm-2.5835 4e-5c-0.21649 0-0.39169 0.15728-0.39169 0.35163v3.53c0 0.19368 0.1752 0.35164 0.39169 0.35164h3.1396c0.21649 0 0.39172-0.15796 0.39172-0.35164v-2.6977l-1.0297 3e-5c-0.16676 0-0.30217-0.12156-0.30217-0.27127v-0.91l-3e-3 -2e-3z" fill="#4D4D4D" />
          </svg>

          <svg version="1.1" class="item" viewBox="0 0 4.2333 3.3037" xmlns="http://www.w3.org/2000/svg">
            <rect x=".3916" y=".32779" width="3.5164" height="2.6481" fill="#FFFFFF"/>
            <path d="m0.66404 0-0.66404 0.6811v2.6221l4.2333 5.167e-4v-3.2918l-3.2923-0.010852v-0.00103zm0.27699 0.48214h2.8226v2.3523h-3.2933v-1.8934h0.47077z" />
          </svg>
-->
        </template>
      </div>
      <div
        class="name"
        ref="name"
      >{{ name }}</div>
    </div>
    <div
      v-if="root && !folderIs"
      class="children opened empty"
    >
        <div class="wrapper2">
          <div class="node"><div class="info"><div class="name">элементов нет</div></div></div>
        </div>
    </div>
    <div
      class="children"
      v-else-if="( data.children && Array.isArray( data.children ) && data.children.length ) || data.url"
      :class="openedIs ? 'opened' : ''"
    >
      <div class="wrapper2" v-if="data.url" v-show="fetching">
        <div class="node">
          <div class="info">
            <div class="loading"></div>
          </div>
        </div>
      </div>
      <template v-else>
        <div class="wrapper1" v-if="childrenNotLast.length">
          <TreeNode
            v-for="node in childrenNotLast"
            :key="node.id"

            :data="node"
            :selectedId="selectedId"
            :CSSnames="CSSnames"

            @selected="$emit( 'selected', $event )"
            @fetch="$emit( 'fetch', $event )"
          />
        </div>
        <div class="wrapper2">
          <TreeNode
            :key="childrenLast.id"

            :data="childrenLast"
            :selectedId="selectedId"
            :CSSnames="CSSnames"

            @selected="$emit( 'selected', $event )"
            @fetch="$emit( 'fetch', $event )"
          />
        </div>
      </template>
    </div>
  </div>
</template>

<script>
export default {
  name: "TreeNode",

  components: {
  },

  me( el, sh, dh, singleUsec, cancelUsec ) {
    let mdt = 0;
    let clicks = 0;
    let th = null;

    if ( !sh ) {
      sh = e => {
		    el.dispatchEvent( new MouseEvent( "click", { ...e, bubbles: true, view: window, cancelable: true } ) )
      };
    }
    if ( !dh ) {
      dh = e => {
		    el.dispatchEvent( new MouseEvent( "dblclick", { ...e, bubbles: true, cancelable: true } ) );
      };
    }

    if ( !singleUsec ) singleUsec = 100;
    if ( !cancelUsec ) cancelUsec = 200;

    const stop = () => {
      if ( th ) {
        clearTimeout( th );
        th = null;
      }

      clicks = 0;
      mdt = 0;
    };

    el.addEventListener(
      "mousedown",
      e => {
        if ( th ) {
          clearTimeout( th );
          th = null;
        }
        const t = window.performance.now();
        if ( t - mdt  > cancelUsec ) stop();
        mdt = t;

        e.preventDefault();
        return false;
      }
    )

    el.addEventListener(
      "mouseup",
      e => {
        const t = window.performance.now();
        if ( t - mdt  > cancelUsec ) {
          stop();
          sh( e );
        }
        else {
          mdt = t;

          clicks++;

          if ( clicks >= 2 ) {
            stop();
            dh( e );
          }
          else {
            if ( th ) clearTimeout( th );
            th = setTimeout( () => { stop(); sh( e ); }, singleUsec );
          }
        }

        e.preventDefault();
        return false;
      }
    );

    el.addEventListener(
      "mouseout",
      e => {
        if ( mdt && !el.contains( e.target ) ) stop();
      }
    );
  },

  props: {
    data: {
      type: Object,
      required: true,
      validator: function( v ) {
        return typeof( v ) === "object" && v !== null && ( "name" in v ) && ( "id" in v );
      }
    },
    root: {
      type: Boolean,
      default: false
    },
    selectedId: {
      type: String,
      default: null
    },
    CSSnames: {
      type: Function,
      default: i => i.marked ? "marked" : ""
    }
  },
  data() {
    return {
      opened: !!this.data.opened,
      fetching: false
    };
  },
  mounted() {
    if ( this.$refs.name ) {
      //sing click - select
      //double - open/close
      //double handler is empty cause dblclick generated by upper level element
      this.$options.me(
        this.$refs.name,
        () => {
          this.$emit( "selected", this.data );
        },
        () => {}
      );
    }

    if ( this.data.id === this.selectedId ) {
      this.$refs.node.scrollIntoView( true );
    }
  },
  methods: {
    CSSnames_() {
      let names = this.CSSnames( this.data );

      if ( this.root ) names += " root";
      if ( this.openedIs ) names += " opened";

      if ( this.data.selected || this.data.id === this.selectedId ) names += " selected";

      if ( this.data.marked ) names += " marked";

      return names;
    },

    async openclose( state ) {
      if ( state === undefined ) state = !this.opened;

      if ( state && this.data.url && !this.fetching ) {
        this.fetching = true;
        this.$emit( "fetch", this.data );
        await this.$nextTick();
      }

      if ( this.$options.teh ) this.$options.teh();

      const node = this.$refs.node;
      if ( node ) {
        const children = node.querySelector( ".children" );

        if ( children ) {
          if ( state ) {
            children.offsetHeight;
            children.style.maxHeight = children.scrollHeight + "px";
            children.style.opacity = "1";
            this.opened = true;
          }
          else {
            children.style.maxHeight = children.scrollHeight + "px";
            children.offsetHeight;
            children.style.maxHeight = "0px";
            children.style.opacity = "0";

            this.opened = false;
          }

          this.$options.teh = () => {
            const node = this.$refs.node;
            if ( node ) {
              const children = this.$refs.node.querySelector( ".children" );
              if ( children ) {
                children.removeEventListener( "transitionend", this.$options.teh );
                this.$options.teh = null;
                if ( children.style.opacity == "1" ) children.style.maxHeight = "unset";
              }
            }
          };

          children.addEventListener( "transitionend", this.$options.teh );
        }
        else this.opened = state;
      }
    }
  },
  computed: {
    name() {
      return this.data.name;
    },
    folderIs() {
      return ( this.data.children && this.data.children.length > 0 ) || this.data.url;
    },
    openedIs() {
      return this.root || ( this.folderIs && this.opened );
    },
    childrenNotLast() {
      return this.data.children.slice( 0, -1 );
    },
    childrenLast() {
      return this.data.children[ this.data.children.length - 1 ];
    }
  },
  watch: {
    data: {
      immediate: true,
      handler( v ) {
        if ( "opened" in v ) this.opened = !!v.opened;
        if ( this.fetching && !v.url ) {
          this.fetching = false;
          if ( this.opened ) {
            this.openclose( false );
            this.$nextTick( () => this.openclose( true ) );
          }
        }
      }
    }
  }
};
</script>

<style scoped>
  .node {
    position: relative;
    padding-top: 0.7em;
  }

  .info {
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    position: relative;
    align-items: flex-start;
    justify-content: flex-start;
    padding-left: 1.5em;
  }

  .info:before {
    content: "";
    position: absolute;
    top: 0.5em;
    left: 0;
    width: 1.5em;
    height: 2px;
    line-height: 0;
    background-image: url(data:image/svg+xml;charset=utf-8,%3Csvg%20version%3D%221.1%22%20viewBox%3D%220%200%201.2%200.6%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%0D%0A%09%3Cpath%20d%3D%22m0%200.6v-0.6h0.6v0.6z%22%20shape-rendering%3D%22crispEdges%22%20fill%3D%22%23C4C4C4%22%20%2F%3E%0D%0A%3C%2Fsvg%3E);
    background-repeat: repeat-x;
    background-position: 0 50%;
    background-size: auto 2px;
  }

  .node > .info:after,
  .children > .wrapper1:after,
  .children > .wrapper2:after {
    content: "";
    position: absolute;
    width: 2px;
    background-image: url(data:image/svg+xml;charset=utf-8,%3Csvg%20version%3D%221.1%22%20viewBox%3D%220%200%200.6%201.2%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%0D%0A%09%3Cpath%20d%3D%22m0%200.6v-0.6h0.6v0.6z%22%20shape-rendering%3D%22crispEdges%22%20fill%3D%22%23C4C4C4%22%20%2F%3E%0D%0A%3C%2Fsvg%3E);
    background-repeat: repeat-y;
    background-position: 0 0;
    background-size: 2px auto;
  }
  .children.empty {
    pointer-events: none;
  }
  .children.empty .name {
    text-transform: uppercase;
    font-weight: bold;
    font-size: 0.6em;
    margin-top: 0.2em;
  }

  .node > .info:after {
    top: 1.2em;
    left: 2em;
    bottom: 0;
    opacity: 0;
    transition: all 0.2s ease-in-out;
  }
  .node.opened > .info:after {
    opacity: 1;
  }

  .children {
    margin-left: 2em;
    position: relative;
  }
  .children > .wrapper1,
  .children > .wrapper2 {
    position: relative;
  }
  .children > .wrapper1:after {
    top: 0;
    left: 0;
    bottom: 0;
  }
  .children > .wrapper2:after {
    top: 0;
    left: 0;
    height: 1.2em;
  }
  .children > .wrapper2 > .node > .info > .loading {
    width: 1em;
    height: 1em;
    background-image: url(data:image/svg+xml;charset=utf-8,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20viewBox%3D%220%200%202400%202400%22%20width%3D%2232%22%20height%3D%2232%22%3E%3Cg%20stroke-width%3D%22200%22%20stroke-linecap%3D%22round%22%20stroke%3D%22%23000%22%20fill%3D%22none%22%3E%3Cpath%20d%3D%22M1200%20600V100%22%2F%3E%3Cpath%20opacity%3D%22.5%22%20d%3D%22M1200%202300v-500%22%2F%3E%3Cpath%20opacity%3D%22.917%22%20d%3D%22M900%20680.4l-250-433%22%2F%3E%3Cpath%20opacity%3D%22.417%22%20d%3D%22M1750%202152.6l-250-433%22%2F%3E%3Cpath%20opacity%3D%22.833%22%20d%3D%22M680.4%20900l-433-250%22%2F%3E%3Cpath%20opacity%3D%22.333%22%20d%3D%22M2152.6%201750l-433-250%22%2F%3E%3Cpath%20opacity%3D%22.75%22%20d%3D%22M600%201200H100%22%2F%3E%3Cpath%20opacity%3D%22.25%22%20d%3D%22M2300%201200h-500%22%2F%3E%3Cpath%20opacity%3D%22.667%22%20d%3D%22M680.4%201500l-433%20250%22%2F%3E%3Cpath%20opacity%3D%22.167%22%20d%3D%22M2152.6%20650l-433%20250%22%2F%3E%3Cpath%20opacity%3D%22.583%22%20d%3D%22M900%201719.6l-250%20433%22%2F%3E%3Cpath%20opacity%3D%22.083%22%20d%3D%22M1750%20247.4l-250%20433%22%2F%3E%3CanimateTransform%20attributeName%3D%22transform%22%20attributeType%3D%22XML%22%20type%3D%22rotate%22%20keyTimes%3D%220%3B0.08333%3B0.16667%3B0.25%3B0.33333%3B0.41667%3B0.5%3B0.58333%3B0.66667%3B0.75%3B0.83333%3B0.91667%22%20values%3D%220%201199%201199%3B30%201199%201199%3B60%201199%201199%3B90%201199%201199%3B120%201199%201199%3B150%201199%201199%3B180%201199%201199%3B210%201199%201199%3B240%201199%201199%3B270%201199%201199%3B300%201199%201199%3B330%201199%201199%22%20dur%3D%220.83333s%22%20begin%3D%220s%22%20repeatCount%3D%22indefinite%22%20calcMode%3D%22discrete%22%2F%3E%3C%2Fg%3E%3C%2Fsvg%3E);
    background-repeat: no-repeat;
    background-position: 50% 50%;
    background-size: 1em 1em;
  }

  .info > .icons {
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    align-items: center;
    margin-right: 0.1em;
  }

  .info > .icons > .opener {
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    align-items: flex-start;
    cursor: pointer;
  }
  .info > .icons svg {
    margin: 0.1em;
    height: 1em;
    width: auto;
    transition: all 0.1s ease-in-out;
  }
  .info > .icons > .opener:hover svg {
    fill: #246FB0;
  }

  .info > .icons > .folder {
    height: 1em;
    width: auto;
    margin-right: 0.5em;
  }

  .info > .icons > .item {
    height: 1em;
    width: auto;
  }

  .info > .name {
    cursor: pointer;
    word-break: break-word;
    padding: 0 0.2em;
    border-radius: 0.2em;
    transition: all 0.1s ease-in-out;
  }
  .info > .name:hover {
    color: #246FB0;
  }
  .node.selected > .info > .name {
    background-color: #007BC1;
    color: #FFFFFF;
  }
  .node.selected > .info > .icons .item *,
  .node.selected > .info > .icons .folder * {
    fill: #007BC1;
  }
  .node.marked > .info > .name {
    font-weight: bold;
  }

  .children {
    transition: all 0.2s ease-in-out;
    overflow-y: hidden;
    max-height: 0;
    opacity: 0;
  }
  .children.opened {
    opacity: 1;
    max-height: unset;
  }



  .root {
    position: relative;
    padding-top: 32px;
  }
  .root::after {
    content: "";
    position: absolute;
    top: 0;
    left: 5px;
    height: 32px;
    width: 32px;
    background-image: url(data:image/svg+xml;charset=utf-8,%3Csvg%20version%3D%221.1%22%20viewBox%3D%220%200%204.2332%204.947%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%0D%0A%09%3Cpath%20d%3D%22m4.08%200.5c-0.0815%200-0.15077%200.0652-0.15077%200.15078v3.7122c0%200.15484-0.12632%200.28524-0.28524%200.28524h-3.0856c-0.12225%200-0.22819-0.0815-0.26079-0.1956-8e-3%20-0.0244-0.0122-0.053-0.0122-0.0815%204e-3%20-0.12224%200.0743-0.22004%200.18839-0.25264%200.0245-8e-3%200.0489-0.0122%200.0774-0.0122h2.7627c0.16708%200%200.3097-0.10595%200.35859-0.25672%200.0123-0.0367%200.0204-0.0774%200.0204-0.12224v-3.4433c0-0.0367-8e-3%20-0.0733-0.0204-0.10594-0.0407-0.10595-0.14669-0.18338-0.26894-0.18338h-3.1173c-0.15891%200-0.28931%200.1304-0.28931%200.28932%208e-3%201.3584-0.01%202.7425-1e-3%204.0912%200%200.0367%204e-3%200.0734%200.0122%200.10595%200.0489%200.26079%200.28117%200.46047%200.55418%200.46047h3.0856c0.29339%200%200.53788-0.22004%200.57456-0.50121%204e-3%20-0.0245%204e-3%20-0.053%204e-3%20-0.0774v-3.7122c0-0.0815-0.0652-0.15077-0.14669-0.15077z%22%20fill%3D%22%234D4D4D%22%20shape-rendering_%3D%22crispEdges%22%20%2F%3E%0D%0A%3C%2Fsvg%3E);
    background-repeat: no-repeat;
    background-size: 24px auto;
    background-position: 0 0;
  }

  .root > .children {
    margin-left: 1em;
  }
</style>